import { cx } from '@flowus/common/cx';
import type { NotificationDTO } from '@next-space/fe-api-idl/lib/models/NotificationDTO';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Icon } from 'src/common/components/icon';
import { LoadingContainer } from 'src/common/components/loading-container';
import { publicLink, SPECIAL_SPACE_ID, TIME_FORMAT } from 'src/common/const';
import { request } from 'src/common/request';

interface Props {
  className?: string;
  onCloseModal?: () => void;
}
/**
 * 使用秘笈
 * 接口文档https://flowus.cn/05e8dc18-0f75-46cb-8630-3a259a4d07a2
 */
export const StrateGuides: FC<Props> = (props) => {
  const [notifications, setNotifications] = useState<NotificationDTO[]>();

  useEffect(() => {
    void request.editor
      .getNotificationList(SPECIAL_SPACE_ID, 'strategyGuides', 1, 50)
      .then((res) => {
        const results: NotificationDTO[] = [];
        res.notificationIds?.forEach((id) => {
          const notification = res.recordMap?.notifications?.[id];
          notification && results.push(notification);
        });
        setNotifications(results);
      });
  }, []);
  const now = useMemo(() => dayjs(), []);
  return (
    <div className={cx('overflow-auto px-4 py-1.5', props.className)}>
      <a
        hidden={__BUILD_IN__}
        className="mt-2.5 flex h-10 items-center justify-between border-[1px] rounded-md border-grey6 border-solid px-2.5 cursor-pointer"
        target={'_blank'}
        href={publicLink.videoTeaching}
      >
        <div className="text-t2-medium">教学视频</div>
        <Icon
          name={'IcArrowDateNext'}
          size="middle"
          style={{
            color: 'var(--grey3)',
          }}
        />
      </a>
      {!notifications && <LoadingContainer className="mt-40" />}
      {notifications?.map((v) => {
        const time = dayjs(v.createdAt);
        const timeLabel = time.isSame(now, 'day')
          ? time.format(TIME_FORMAT)
          : time.isSame(now, 'year')
          ? time.format('M月D日 HH:mm')
          : time.format('YYYY年M月D日 HH:mm');
        return v.edits?.map((e, index) => {
          return (
            <div className="mt-4 " key={index}>
              <div className="w-full text-center text-t4 text-grey4 mb-2.5">{timeLabel}</div>
              <div
                className="border-[1px] border-grey6 border-solid rounded-md cursor-pointer shadow pb-2.5"
                onClick={() => {
                  window.open(e.strategyGuidesProperty?.jumpUrl);
                }}
              >
                <img className="w-full object-cover" src={e.strategyGuidesProperty?.banner}></img>
                <div className="flex flex-col items-center px-2.5 overflow-auto">
                  <div className="w-full mt-3 text-t2-medium text-ellipsis">
                    {e.strategyGuidesProperty?.title}
                  </div>
                  <div className="w-full mt-[2px] text-t4 text-grey3 text-ellipsis">
                    {e.strategyGuidesProperty?.description}
                  </div>
                </div>
              </div>
            </div>
          );
        });
      })}
    </div>
  );
};
